import React from 'react';

import { handleUnit, formatCurrency } from 'lib/utils';

/**
 *
 * @param {Object} props
 * @param {number} props.price - inclusive vat price
 * @param {number} props.excVATPrice - exclusive vat price
 * @param {number} props.quantity - product 'quantity' value
 * @param {string} props.unit - product unit value
 * @param {boolean} props.incVat - VAT Toggle state (true = show inc VAT/ false = show exc VAT)
 */
const VATPrice = ({ price, excVATPrice, quantity, unit, incVat }) => (
  <div className="cef-vat-price">
    <p className="cef-vat-price__main" data-testid="vat-price-main">
      <span className="cef-vat-price__currency">&pound;</span>
      {incVat ? formatCurrency(excVATPrice) : formatCurrency(price)}
      <span className="cef-vat-price__per">
        For {quantity}
        {handleUnit(unit)}
      </span>
    </p>

    <p className="cef-vat-price__secondary" data-testid="vat-price-secondary">
      &pound;{incVat ? formatCurrency(price) : formatCurrency(excVATPrice)}{' '}
      {incVat ? 'Inc' : 'Ex'} VAT
    </p>
  </div>
);

export default VATPrice;
